module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAWCAYAAAD0OH0aAAAAAXNSR0IArs4c6QAAASJJREFUOBGVlDEOgkAQRWExxM7WmgtwAw0JghUtrSZ6BD2Eh1BPYGHFAgnRxAN4AWtbO0IQ/KOYIMKikwC78N7O5BdInPOV9EexPM8Xvu+v8VR+8RhBWZZN0WkXRVG3TXoKBeQkScKDIOiJpLIgYawBuh3Qqd8kfQgEQdLR6RSGoVYnfQmFpKVpevI8T69KtUIB9WVZPiCMQVkSCTQeBcARu/OWhAJBkLoIYgdpQnsZc+a0+KUw4rK1Q/WgTvVFw/6O93PbtjetAsaIcbmWZe3pMKEA8AbGAXwkmEokXJHQGHV+oa97rYCTL4qijEzTvJRhWn8JgM+qqo4Nw7hWYdp/xAr4yBgbNsEklDvscbILOKYPTfUWtsh4hg6Ut7j+/Qk8AB/vbA8T7ok/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/triangle.png
// module id = wYhO
// module chunks = 3